import React from "react";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";
import * as styles from "./styles.module.css";

const RepriseIframe = ({ data }) => {
    const { demoID, eyebrowText, title, subtitle, iframeAttributes } = data ?? {};

    const demoUrl = `https://app.getreprise.com/launch/${demoID}`;
    let parsedContent = null;

    try {
        // Try to parse the content, if it exists
        parsedContent = (iframeAttributes?.internal?.content && JSON.parse(iframeAttributes.internal.content)) || {};
    } catch (error) {
        console.error("Invalid JSON format, falling back to default values.");
        parsedContent = {}; // Fallback to empty object if parsing fails
    }

    // Destructure width and height with default values
    const { width = "100%", height = "100%" } = parsedContent;

    return (
        <>
            {eyebrowText && <p className="tag-2 uppercase text-sm mt-5 mb-3">{eyebrowText}</p>}
            {title && (
                <h2
                    className={`md:title-3 text-xl my-3.75`}
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(title) }}
                />
            )}
            {subtitle && (
                <h4
                    className={`text-xl my-3.75 tracking-normal`}
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(subtitle) }}
                />
            )}
            <div className={styles.iframeWrapper}>
                <iframe
                    src={demoUrl}
                    title={title}
                    name={subtitle}
                    allow="clipboard-write"
                    style={{ height: height, width: width, opacity: 1, visibility: "visible" }}
                />
            </div>
        </>
    );
};

const ProductDemo = ({ data }) => {
    const { additionalConfiguration, cardItem } = data ?? {};
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration);

    return (
        <section className={`${sectionSpacingClassName}`}>
            <div className="container">
                <RepriseIframe data={cardItem} />
            </div>
        </section>
    );
};

export default ProductDemo;
